/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addSecondaryTokens} from '../api'

export const useMutationAddSecondaryTokens = createReactQueryMutationHook('addSecondaryTokens', addSecondaryTokens)
